import {observer} from "mobx-react";
import {useStore} from "../../../stores/Store";
import {useEffect, useState} from "react";

const russianAddress = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2730.3452377407393!2d37.60223607733945!3d55.75710347308579!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46b54a4f1bb8d08f%3A0xac88457055d02636!2sBryusov%20Pereulok%2C%201%2C%20Moskva%2C%20Russia%2C%20125009!5e1!3m2!1sen!2sch!4v1746371635547!5m2!1sen!2sch"
const otherAddress = "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3300.8276019197074!2d8.0410989!3d47.3628076!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47903b77c4be3807%3A0x132664107e8f7bfc!2su.%20Holzstrasse%209%2C%205036%20Oberentfelden!5e1!3m2!1sen!2sch!4v1695929703151!5m2!1sen!2sch"

const ContactMap = () => {
    const {LanguageStore} = useStore();
    const {currentLanguage} = LanguageStore;
    const [link, setLink] = useState<string>(otherAddress)
    
    const setMap = (currentLanguage: string) => {
        if(currentLanguage === 'ru') setLink(russianAddress)
        else setLink(otherAddress)
    }

    useEffect(() => {
        setMap(currentLanguage);
    }, []);

    useEffect(() => {
        setMap(currentLanguage)
    }, [currentLanguage]);
    
    return (
        <iframe
            src={link}
            width='100%'
            height="450"
            style={{border: 0}}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade">

        </iframe>
    )
}

export default observer(ContactMap)